export const paymentGroupTypes = {
    campaign: 'campaign',
  };
  